import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";
import Link from "next/link";

import { useGetInfo } from "antopolis-react-utils/hooks";

export default function FooterTopRightSection() {
  const axiosPublicInstance = useAxiosPublicInstance();
  const { info: data } = useGetInfo({
    axiosInstance: axiosPublicInstance,
    api: "websiteContents/usefulLinks/",
  });

  return (
    <div className="flex w-full  justify-between pt-8 lg:pt-0  gap-3">
      <div className="font-normal text-lg md:w-1/3  flex flex-col">
        <p className="text-[#D4D4D4] pb-4 text-xs md:text-base">Support</p>
        <div className=" flex flex-col gap-2 hover:*:underline *:duration-300 text-xs md:text-base">
          <Link href={"/contactUs"}>Contact Us</Link>
          <Link href={"/member"}>Become a Member</Link>
        </div>
        <div className="mt-6">
          <p className="text-[#D4D4D4] pb-4 text-xs md:text-base">
            Useful Links
          </p>

          <div className="flex flex-col gap-3">
          {data?.map((item) => (
            <Link
              href={item?.link}
              key={item?._id}
              className="hover:underline  underline-offset-4 decoration-1 "
            >
              <p>{item?.title}</p>
            </Link>
          ))}
          </div>
        </div>
      </div>

      <div className="font-normal text-lg  md:w-1/2">
        <p className="text-[#D4D4D4] pb-4 text-xs md:text-base">Resources</p>
        <div className=" flex flex-col gap-2 hover:*:underline *:duration-300 text-xs md:text-base">
          <Link href={"/about"}>About Us</Link>
          <Link href={"/gallery"}>Gallery</Link>
          <Link href={"/events"}>Events</Link>
          <Link href={"/journals"}>Journal</Link>
          <Link href={"/writeups"}>Write Ups</Link>
          <Link href={"/apbc"}>APBC</Link>
        </div>
      </div>
    </div>
  );
}
